import React from "react";

const InstallPromptModal = ({ open, onInstall, onDismiss, error }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <span className="text-primary font-bold">C</span>
          </div>
          <div>
            <p className="text-base font-semibold text-gray-900">
              Install COMTRACKED
            </p>
            <p className="text-xs text-gray-500">
              Get quick access with a desktop or mobile icon.
            </p>
          </div>
        </div>

        <div className="mt-4 rounded-xl bg-gray-50 p-4 text-xs text-gray-600">
          We'll open the app with seamless SSO next time.
        </div>

        {error && (
          <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
            {error}
          </div>
        )}

        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-lg border border-gray-200 px-4 py-2 text-xs font-medium text-gray-700 hover:bg-gray-100"
          >
            Dismiss
          </button>
          <button
            type="button"
            onClick={onInstall}
            className="rounded-lg bg-primary px-4 py-2 text-xs font-semibold text-white hover:bg-primary/90"
          >
            Install
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPromptModal;
